import * as React from 'react';

export const AddFeedSuggestion = React.lazy(
  () => import('./AddFeedSuggestion')
);

export const ReviewFeedSuggestion = React.lazy(
  () => import('./ReviewFeedSuggestion')
);
